/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Rename_HintInputs */

const vi_irrigation_rename_hint = /** @type {(inputs: Irrigation_Rename_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tên gốc trên SmartLab: ${i?.name}. Để trống để dùng lại tên gốc.`)
};

/**

* @param {Irrigation_Rename_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_rename_hint = /** @type {((inputs: Irrigation_Rename_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Rename_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_rename_hint(inputs)
});